import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default function initInvestmentCalculatorCta() {
  const component = document.getElementById("investmentCalculatorCta")

  if (!component) return

  let buttonVisible = false
  let showed = false

  const numbersObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !buttonVisible) {
          buttonVisible = true
          component.classList.add("pop-up-enter")
          component.classList.remove("opacity-0")
          setTimeout(() => {
            component.classList.remove("pop-up-enter")
          }, 800)
          // Stop observing once visible
          numbersObserver.disconnect()
        }
      })
    },
    { threshold: 0.1 }
  )
  numbersObserver.observe(document.querySelector("#numbers"))

  // ScrollTrigger.create({
  //   trigger: "#become-investor .fund-form-cta",
  //   start: "top center",
  //   onEnter: () => showPopup(),
  //   onEnterBack: () => showPopup(),
  // })

  function showPopup() {
    if (showed || window.location.hash === "#faq") return

    showed = true
    component.classList.add("pop-up-enter")
    window.dispatchEvent(new CustomEvent("cta-calculator-popup-show"))
  }
}
